export default "__VITE_ASSET__HPZnnc9e__ 285w";